export const QUERY_KEYS = {
	GET_STATUS_PIX: 'GET_STATUS_PIX',
	UNICO_GET_STATUS_PROCESS: 'UNICO_GET_STATUS_PROCESS',
	GET_USERS_LIST: 'GET_USERS_LIST'
}